import { useContext } from "react";
import { AccordionItemContext } from "../providers";

export function useAccordionItem() {
  return useContext(AccordionItemContext);
}
